import {
  ImpactOccurredType,
  NotificationOccurredType
} from "@/hooks/useAppInit/utils/initTelegramData"
import { getTgWebApp } from "./tgWebApp"

interface IHapticFeedback {
  type?: "impactOccurred" | "notificationOccurred"
  style?: ImpactOccurredType | NotificationOccurredType
}

export const hapticFeedback = ({
  type = "impactOccurred",
  style = "light"
}: IHapticFeedback = {}) => {
  const haptic = getTgWebApp()?.HapticFeedback

  if (haptic) {
    if (type === "impactOccurred") {
      haptic.impactOccurred(style as ImpactOccurredType)
    } else if (type === "notificationOccurred") {
      haptic.notificationOccurred(style as NotificationOccurredType)
    }
  }
}
